import { Injectable } from '@angular/core';
import { BackendInterceptor } from 'gung-standard';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CarLinerBackendInterceptorService extends BackendInterceptor {
  protected env = environment;

  getBaseUrl(): string {
    return environment.backendUrl;
  }
}
